module.exports = __webpack_public_path__ + "static/media/green-button.881531f2.png";